import React, { useState } from "react";
import { Input,/* Button,*/ Space } from 'antd';
// import { CheckOutlined } from '@ant-design/icons';
import { useMutation } from "@apollo/client";
import { STAND_UPDATE } from "graphql/mutation/stand-gql";
import Icons from "components/icons";
import Craft from 'components/craft';
import { errorNotification } from "components/request-result";
import './stand-shelf-number-field.scss';


const StandShelfNumberField = ({ id, value, craftData, standId }) => {
    const [ shelfNumber, setShelfNumber ] = useState(value);
    const [ error, setError ] = useState(null);
    const [ standUpdate ] = useMutation(STAND_UPDATE);

    const effectiveStandId = standId || id;

    const craftCreateUpdate = craftData ?
        Craft.Hooks.createUpdate({ craftID: craftData?.id ? true : false }) :
        { _setCraftCreateUpdate: null };

    const { _setCraftCreateUpdate } = craftCreateUpdate;

    // const checkboxColor = shelfNumber && shelfNumber.length > 0 ? 'active' : 'inactive';

    const handleChange = (e) => {
        setShelfNumber(e.target.value);
        if (error) setError(null);
    };

    const handleSubmit = () => {
        const isShelfNumberChanged = shelfNumber !== value;

        if (isShelfNumberChanged)
        {
            standUpdate({
                variables: {
                    input: {
                        id,
                        shelf_number: shelfNumber
                    }
                },
                onCompleted: () => {
                    setError(null);
                    const hasValidCraft = craftData && _setCraftCreateUpdate;

                    if (hasValidCraft)
                    {
                        const isShelfNumberEmpty = !shelfNumber || shelfNumber.trim() === '';

                        let newStatus;

                        if (isShelfNumberEmpty) {

                            newStatus = (craftData.status === 'done' || craftData.status === 'collected') ? 'open' : craftData.status;
                        } else {

                            newStatus = 'done';
                        }

                        _setCraftCreateUpdate({
                            variables: {
                                input: {
                                    id: craftData?.id ? +craftData.id : undefined,
                                    stand_id: +effectiveStandId,
                                    status: newStatus,
                                }
                            }
                        });
                    }
                },
                onError(error) {
                    errorNotification(error);
                    let errorMessage = 'error occurred';

                    if (error?.graphQLErrors && error.graphQLErrors.length > 0) {
                        const graphQLError = error.graphQLErrors[0];
                        errorMessage = graphQLError?.extensions?.reason || graphQLError?.message || errorMessage;
                    } else if (error?.extensions?.reason) {
                        errorMessage = error.extensions.reason;
                    } else if (error?.message) {
                        errorMessage = error.message;
                    }

                    setError(errorMessage);
                }
            });
        }
    };

    const handleBlur = () => {
        if (shelfNumber !== value)
        {
            handleSubmit();
        }
    };

    return (
        <div className="stand-shelf-number-field" style={{ position: 'relative' }}>
            <Icons.Shelf className="shelf-icon" />
            <Space
                className="shelf-input-container"
                size={ 0 }>
                <Input
                    size="small"
                    value={ shelfNumber }
                    onChange={ handleChange }
                    onBlur={ (e) => {
                        const relatedTarget = e.relatedTarget;
                        if (!relatedTarget || !relatedTarget.classList.contains('shelf-submit-btn'))
                        {
                            handleBlur();
                        }
                    } }
                    onPressEnter={ handleSubmit }
                />
                {/* <div>
                    <Button
                        className={ `shelf-submit-btn ${ checkboxColor }` }
                        type="primary"
                        icon={ <span> <CheckOutlined /> </span> }
                        onClick={ handleSubmit }
                    />
                </div> */}
            </Space>
            {error && (
                <div className="error-message">
                    {error}
                </div>
            )}
        </div>
    );
}

export default StandShelfNumberField;